import { Component, useEffect, useState } from 'react';
import { inject, observer } from 'mobx-react';
import { find } from 'lodash';

//components
import withLocalization from '~/hoc/withLocalization';

//elements
import CustomMultiSelect from '../../../elements/CustomMultiSelect';
import Select from '../../../elements/Select';

const SkillsWidget = inject('commonStore', 'skillsStore', 'userStore')(
    withLocalization(observer(class SkillsWidget extends Component {
        constructor(props) {
            super(props);
            this.state = {
                skillsOptions: []
            }
        }

        componentDidMount() {
            this.loadSkillsOptions();
        }

        loadSkillsOptions = async () => {
            try {
                const params = { user_id: this.props.user_id };
                const { config } = this.props.commonStore;
                const { allow_resource_planner } = config?.client?.data.basicRules?.workPlanSettings || {};
                if (!allow_resource_planner) return;
                const userSkill = await this.props.skillsStore.getSkillsDetails(params);
                this.setState({ skillsOptions: userSkill });
            } catch (err) {
                console.error(err);
                this.props.commonStore.addNotification(err.message, null, 'error');
            }
        }

        render() {
            const { skillsOptions } = this.state;
            const { t, onChange, value } = this.props;
            const selectedOptions = value ? value.split(',') : [];
            return (
                <CustomMultiSelect
                    options={skillsOptions || []}
                    value={selectedOptions}
                    onChange={(selected) => onChange(selected.join(','))}
                    overrideStrings={{
                        selectSomeItems: t('Select Skills'),
                        allItemsAreSelected: t('All skills are selected'),
                        search: t('Search'),
                        selectAll: t('Select All'),
                        noOptions: t("No skills are available, you can add them in the 'Manage skill matrix' menu under the More Action section of User")
                    }}
                />
            );
        }
    }))
);


const CurrentUserSkills = (props) => {
    const [options, setOptions] = useState([]);
    useEffect(() => {
        loadSkillsOptions(props.user_id);
    }, [props.user_id])

    const loadSkillsOptions = async (user_id) => {
        try {
            let allGroups = props?.commonStore?.config?.client?.data?.extendedRules?.user_groups || [], options = [];
            const pmId = props?.userStore?.currentUser?.user_type === 'pm' ? props?.userStore?.currentUser?.id : 0;
            if (user_id > 0 && !props.isMember) {
                let currentUserSkills = await props.skillsStore.getUserGroups(user_id);
                options = allGroups;
            }
            else {
                options = allGroups;
            }
            setOptions(options);
        }
        catch (err) {
            console.error({ err });
            props.commonStore.addNotification(props.t(err.message ? err.message : 'Something went wrong'), null, 'error');
        }
    }

    if (props.isMember) {
        return <div className='pt-2 fw-bold'>
            {props.value > 0 ? options.find(ele => ele.value = props.value).name : props.t("No Group")}
        </div>
    }

    return (
        <Select
            options={options}
            value={props.value ? find(options, { value: props.value }) : null}
            isDisabled={props.disabled}
            placeholder={props.t("Select Groups")}
            onChange={selected => props.onChange(selected && selected.value ? selected.value : -1)}
            className={"custom-select-max-height-200"}
            isClearable={true}
            noOptionsCustomMessage={props.t("This employee is not part of any Skills, you can add employees to skills from employee profile")}
        />
    )
}

export const CurrentSkillsWidget = inject('commonStore', 'skillsStore', 'userStore')(withLocalization(CurrentUserSkills));

export const SingleSkillsWidget = observer(class SingleSkillsWidget extends Component {
    render() {
        return <SkillsWidget mode="assign" {...this.props} />;
    }
});

export const UsersFromSkillsWidget = observer(class UsersFromSkillsWidget extends Component {
    render() {
        return <SkillsWidget mode="getUsersInSkill" {...this.props} />;
    }
});
